import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Container, useMediaQuery } from "@mui/material";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { aboutus1, aboutus2, aboutus3 } from "../../assets/";

gsap.registerPlugin(ScrollTrigger);

const AboutUsSection = () => {
  const sectionRef = useRef(null);
  const textRef1 = useRef(null);
  const textRef2 = useRef(null);
  const isMobile = useMediaQuery("(max-width: 600px)");

  useEffect(() => {
    const textElements = [textRef1.current, textRef2.current];

    textElements.forEach((el) => {
      if (el) {
        gsap.fromTo(
          el,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 87%", // Starts animation when 80% of section is visible
              toggleActions: "play none none reverse", // Play animation on enter, reverse on exit
            },
          }
        );
      }
    });
  }, []);

  return (
    <Box
      ref={sectionRef}
      sx={{
        position: "relative",
        width: "100%",
        height: "auto",
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        px: { xs: 0, md: 4 },
        py: { xs: 3, md: 4 },
      }}
    >
        <Container maxWidth={isMobile ? false : "xl"}>
        <Box sx={{ textAlign: "left", mb: 1 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: "600",
              fontSize: "28px",
              background: "linear-gradient(90deg, #bf742c, rgb(252, 243, 202), #c58038)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
              fontFamily: "LEMON MILK",
              mb: 4,
            }}
          >
            About Us
          </Typography>
        </Box>

        <Container maxWidth={isMobile ? false : "xl"}>
          <Box sx={{ textAlign: "center", mb: 4, ml: { xs: 0, md: 4 }, mt: 2 }}>
            <span
              ref={textRef1} // ✅ Apply GSAP animation to this text
              style={{
                fontSize: isMobile ? "12px" : "13.5px",
                textAlign: "center",
                fontWeight: "300",
                fontFamily: "LEMON MILK",
                letterSpacing: "0.8px",
                color: "rgba(180, 180, 180, 0.8)",
                display: "block",
                margin: "0 auto",
                opacity: 0, 
                lineHeight: "1.6",
              }}
            >
              At Kolla Group, we take pride in creating luxury real estate assets that stand the test of time. For us, luxury is defined by an unwavering commitment to superior craftsmanship, meticulous attention to detail & the highest standards of quality. 
             
             <br/><br />
             With a legacy built on trust & excellence, we have established ourselves as a distinguished name in the industry, consistently delivering landmark residential projects in prime locations.
             </span>
          </Box>

          <Box sx={{ textAlign: "center", mb: 2, ml: { xs: 0, md: 4 } }}>
            <span
              ref={textRef2} 
              style={{
                fontSize: isMobile ? "12px" : "13.5px",
                textAlign: "center",
                fontWeight: "300",
                fontFamily: "LEMON MILK",

               letterSpacing: "0.8px",
                color: "rgba(180, 180, 180, 0.8)",
                display: "block",
                margin: "0 auto",
                opacity: 0, 
                lineHeight: "1.6",
                marginTop: "20px",
              }}
            >
              With over three decades of expertise, we have successfully developed more than 4 million square feet of land, with an additional 4 million square feet in progress. Our legacy is reflected in the trust of 1,000+ happy families who have chosen to make our communities their home.            </span>
          </Box>
        </Container>
      </Container>
    </Box>
  );
};

export default AboutUsSection;
